import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueFlashMessage from 'vue-flash-message'
import JsonCSV from 'vue-json-csv'
import Loading from 'vue-loading-overlay'

// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
require('vue-flash-message/dist/vue-flash-message.min.css')

Vue.use(BootstrapVue)
Vue.use(require('vue-moment'))
Vue.use(Loading)
Vue.use(VueFlashMessage, {
  messageOptions: {
    timeout: 4000
  }
})

Vue.component('downloadCsv', JsonCSV)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App, VueFlashMessage
  }
})
